import React, { useEffect, useState } from "react";
import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import theme from "../styles/theme";

const BannerComponent = ({
  title,
}: {
  title: string;
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const mobileBanner = useMediaQuery(theme.breakpoints.down("sm"));

  const [activeImage, setActiveImage] = useState(0);
  const [time, setTime] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 5000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    setActiveImage((activeImage + 1)%5);
  }, [time]);
  
  const location = useLocation();
  const currentPage = location.pathname.slice(1);
  // Static banner images for each route
  const bannerImages = {
    "": "/images/HomeMosaic.jpg",
    courses: mobileBanner ? "/images/Banners/MobileBanner1.png" : "/images/Banners/Banner4.png",
    register: mobileBanner ? "/images/Banners/MobileBanner2.png" : "/images/Banners/Banner2.png",
    "online-course": mobileBanner ? "/images/Banners/MobileBanner3.png" : "/images/Banners/Banner1.png",
    contact: mobileBanner ? "/images/Banners/MobileBanner4.png" : "/images/Banners/Banner7.png",
    resources: mobileBanner ? "/images/Banners/MobileBanner5.png" : "/images/Banners/Banner5.png",
  };

  const mainPageBanners = mobileBanner ? [
    "/images/Banners/MobileBanner1.png",
    "/images/Banners/MobileBanner2.png",
    "/images/Banners/MobileBanner3.png",
    "/images/Banners/MobileBanner4.png",
    "/images/Banners/MobileBanner5.png",
  ] 
  : [
    "/images/Banners/Banner1.png",
    "/images/Banners/Banner2.png",
    "/images/Banners/Banner3.png",
    "/images/Banners/Banner4.png",
    "/images/Banners/Banner5.png",
    "/images/Banners/Banner6.png",
  ];

  const defaultImage = "/HomeMosaic.jpg";
  var staticBannerImage = !currentPage ? mainPageBanners[activeImage] || defaultImage : bannerImages[currentPage as keyof typeof bannerImages] || defaultImage

  return (
    <Box
      sx={{
        position: "relative",
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
        marginRight: "calc(-50vw + 50%)",
        marginTop: 0,
        marginBottom: 1,
      }}
    >
      <img style={isMobile ? { maxHeight: "420px", height: "230px", width: "100%"} : {width: "100%", height: "380px"}} alt="" src={staticBannerImage} /> 
      <Container
        sx={{
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          height: "100%",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "8%",
            left: "0",
            backgroundColor: "rgba(0, 38, 58, 0.65)", // Dark blue with 80% opacity
            padding: "1rem",
            maxWidth: "430px",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontWeight: 300,
              fontSize: { xs: "44px", md: "44px" },
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default BannerComponent;
